import React, { useContext } from 'react';
import StatusCodeContext from '../../server/StatusCodeContext';

const NotFound = () => {
  const { setStatusCode } = useContext(StatusCodeContext);

  const httpStatus = {
    status: 404
  };

  if (__SERVER__) {
    setStatusCode(httpStatus);
  }

  return <h1>404 : Not Found</h1>;
};

export default NotFound;
